import { createSlice } from "@reduxjs/toolkit";
import logger from "../../utils/common";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    domain: "",
    frappetoken: undefined,
    userData: undefined,
    email: "",
    csrfToken: "",
    language: "nl",
  },
  reducers: {
    domainAction: (state, action) => {
      return (state = {
        ...state,
        domain: action.payload,
      });
    },
    tokenAction: (state, action) => {
      return (state = {
        ...state,
        frappetoken: action.payload,
      });
    },
    userAction: (state, action) => {
      return (state = {
        ...state,
        userData: { ...action.payload },
      });
    },
    emailAction: (state, action) => {
      return (state = {
        ...state,
        email: action.payload,
      });
    },
    logoutAction: (state, action) => {
      return (state = {
        ...state,
        domain: "",
        frappetoken: undefined,
        userData: undefined,
        email: "",
        csrfToken: "",
        // language: window.navigator.language || "en",
      });
    },
    csrfTokenAction: (state, action) => {
      return (state = {
        ...state,
        csrfToken: action.payload,
      });
    },
    setLanguageAction: (state, action) => {
      return (state = {
        ...state,
        language: action.payload,
      });
    },
  },
});

export const {
  domainAction,
  tokenAction,
  userAction,
  emailAction,
  logoutAction,
  csrfTokenAction,
  setLanguageAction,
} = authSlice.actions;

export const domainUpdate = (data) => async (dispatch) => {
  try {
    dispatch(domainAction(data));
  } catch (error) {
    logger(error);
  }
};
export const tokenUpdate = (data) => async (dispatch) => {
  try {
    dispatch(tokenAction(data));
  } catch (error) {
    logger(error);
  }
};
export const userDataUpdate = (data) => async (dispatch) => {
  try {
    dispatch(userAction(data));
  } catch (error) {
    logger(error);
  }
};
export const userEmailUpdate = (data) => async (dispatch) => {
  try {
    dispatch(emailAction(data));
  } catch (error) {
    logger(error);
  }
};
export const callLogout = () => async (dispatch) => {
  try {
    dispatch(logoutAction());
  } catch (error) {
    logger(error);
  }
};
export const setCsrfToken = (data) => async (dispatch) => {
  try {
    dispatch(csrfTokenAction(data));
  } catch (error) {
    logger(error);
  }
};
export const setLanguage = (data) => async (dispatch) => {
  try {
    dispatch(setLanguageAction(data));
  } catch (error) {
    logger(error);
  }
};
export const selectDomainData = (state) => state.auth.domain;
export const selectTokenData = (state) => state.auth.frappetoken;
export const selectUserData = (state) => state.auth.userData;
export const selectUserEmail = (state) => state.auth.email;
export const selectCsrfTokenData = (state) => state.auth.csrfToken;
export const selectLanguage = (state) => state.auth.language;

export default authSlice.reducer;
